module.exports = __webpack_public_path__ + "img/33.60c5a8d6.png";